import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { Callout } from "@radix-ui/themes";
import i18next from "i18next";
import React, { memo } from "react";

const FormErrorMessage: React.FunctionComponent<{
  text: string | undefined;
  isVisible: boolean;
}> = ({ text, isVisible }) => {
  return (
    <>
      {isVisible && (
        <Callout.Root color="red">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>
            {i18next.t("feedback.error")} {text ?? "Some error occurred."}
          </Callout.Text>
        </Callout.Root>
      )}
    </>
  );
};

export default memo(FormErrorMessage);
